//to write constant Data's

export const months = [
  "All",
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export const roles = ["All", "RM/RMA", "SRM", "OPS", "SERVICE & OPS"];

export const userRoles = [
  {
    value: "",
    label: "All",
  },
  {
    value: "RM/RMA",
    label: "RM/RMA",
  },
  {
    value: "SRM",
    label: "SRM",
  },
  {
    value: "OPS",
    label: "OPS",
  },
];

export const routerPath = {
  taskTracker: "/dashboard/tasktracker",
  deskAssetMapping: (id) => `/deskManagement/assetMapping/${id}`,
};
